import React from 'react';

export default function LoadingAdvice() {

    return (
        <div >Loading ...</div>
    )
};
